import { useState } from 'react';
import { apiURL } from '../../consts/URLs';
import { MANUFACTURERS } from '../endpointList';
import { fetchRequest, getOptions } from '../utils';
import { getCookie } from '../../utils/handleCookie';
import { cookieName } from '../../consts/cookie';

// export interface manufacturer {
//     name: string;
//     ordering: string;
// }

const token = getCookie(cookieName.token);

const useManufacturers = () => {
    const [manufacturerResponse, setManufacturerResponse] = useState<any>();
    const [manufacturerResult, setManufacturerResult] = useState<any>();

    const [getManufacturerResponse, setGetManufacturerResponse] = useState<any>();
    const [getManufacturerResult, setGetManufacturerResult] = useState<any>();

    const [deleteManufacturerResponse, setDeleteManufacturerResponse] = useState<any>();
    const [deleteManufacturerResult, setDeleteManufacturerResult] = useState<any>();

    const [updateManufacturerResponse, setUpdateManufacturerResponse] = useState<any>();
    const [updateManufacturerResult, setUpdateManufacturerResult] = useState<any>();

    const buildManufacturerUrl = (baseUrl: string, data: Record<string, any>) => {
        const params = new URLSearchParams();

        Object.entries(data).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '' && key !== 'id') {
                params.append(key, value);
            }
        });

        return `${baseUrl}?${params.toString()}`;
    };

    const createManufacturer = (obj: any) => {
        const url = `${apiURL}/${MANUFACTURERS}`;
        const urlWithQuerys = buildManufacturerUrl(url, obj);
        const options = getOptions({ method: 'POST', token: token });
        fetchRequest(urlWithQuerys, options, setManufacturerResponse, setManufacturerResult);
    };

    const getManufacturer = () => {
        const url = `${apiURL}/${MANUFACTURERS}`;
        const options = getOptions({ method: 'GET', token: token });
        fetchRequest(url, options, setGetManufacturerResponse, setGetManufacturerResult);
    };

    const updateManufacturer = (obj: any, id: number) => {
        const url = `${apiURL}/${MANUFACTURERS}/${id}`;
        const urlWithQuerys = buildManufacturerUrl(url, obj);
        const options = getOptions({ method: 'PUT', token: token });
        fetchRequest(urlWithQuerys, options, setUpdateManufacturerResponse, setUpdateManufacturerResult);
    };

    const deleteManufacturer = (id: number) => {
        const url = `${apiURL}/${MANUFACTURERS}/${id}/delete`;
        const options = getOptions({ method: 'DELETE', token: token });
        fetchRequest(url, options, setDeleteManufacturerResponse, setDeleteManufacturerResult);
    };

    const RESPONSES = {
        manufacturerResponse,
        getManufacturerResponse,
        deleteManufacturerResponse,
        updateManufacturerResponse,
    };

    const RESULTS = {
        manufacturerResult,
        getManufacturerResult,
        deleteManufacturerResult,
        updateManufacturerResult,
    };

    const CTAs = {
        createManufacturer,
        getManufacturer,
        deleteManufacturer,
        updateManufacturer,
    };

    return { RESPONSES, RESULTS, CTAs };
};
export default useManufacturers;
